import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { InventoryItem } from 'services';
import { ecommerce_manager, account_manager } from 'utils/constants';
import { Results, CreateModal } from './components';
import EmptyState from 'components/EmptyState';
import { Card, Button } from '@material-ui/core';

const InventoryItemList = props => {
  let { inventory } = props;
  const Head = props => {
    let { handleCreateOpen, ...rest } = props;
    return (
      <GenericHeader
        header="Inventory Items"
        subheader="Inventory Management" {...rest} >
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Add Item
        </Button>
      </GenericHeader>
    );
  }
  if (!inventory) return (
    <Card>
      <EmptyState active={true} message="This inventory is not created yet" />
    </Card>
  )
  return (
    <ListComp
      listing={InventoryItem.list}
      title="Inventory Items"
      name="inventory"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      CreateComp={CreateModal}
      comp_props={{ create_comp: { inventoryId: inventory.id } }}
      roles={[ecommerce_manager, account_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", inventory: inventory.id }}
    />
  );
};

export default InventoryItemList;
